import 'lazysizes'
import { forwardRef, type MutableRefObject, useEffect } from 'react'
import { Image } from './ResponsiveImage.styles'
import type { ResponsiveImageProps } from './ResponsiveImage.types'

const ResponsiveImage = forwardRef<HTMLImageElement, ResponsiveImageProps>(
  (props, ref) => {
    const {
      sources,
      className = '',
      lqip = false,
      blurRadius = 5,
      transitionDuration = 400,
      sizes,
      showDefault,
      imgSrc,
      imgDataSrc,
      lazyload = false,
      fetchPriority,
      ...additionalNativeProps
    } = props

    const srcSet = sources
      ?.map((source) => `${source.src} ${source.width}`)
      .join(', ')

    useEffect(() => {
      if (!(ref as MutableRefObject<HTMLImageElement> | null)?.current) {
        return
      }
      ;(
        ref as MutableRefObject<HTMLImageElement> | null
      )?.current.classList.add('lazyload')
    }, [imgSrc, sources, ref])

    return (
      <Image
        ref={ref}
        className={`${className} ${lazyload ? 'lazyload' : ''}`}
        transitionDuration={transitionDuration}
        blurRadius={blurRadius}
        lqip={lqip}
        src={
          imgSrc ??
          (showDefault
            ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjOHPmzH8ACDADZKt3GNsAAAAASUVORK5CYII='
            : '')
        }
        {...(imgDataSrc && { 'data-src': imgDataSrc })}
        {...(lazyload
          ? { 'data-sizes': sizes ?? 'auto' }
          : srcSet && { sizes: sizes ?? '' })}
        {...(srcSet && (lazyload ? { 'data-srcset': srcSet } : { srcSet }))}
        {...additionalNativeProps}
        {...(fetchPriority &&
          ({ fetchpriority: fetchPriority } as Record<string, string>))}
      />
    )
  },
)

ResponsiveImage.displayName = 'ResponsiveImage'

export { ResponsiveImage }
